export default [
  {
    displayText: 'Any',
    value: null,
  }, {
    displayText: '$100,000',
    value: 100000,
  }, {
    displayText: '$150,000',
    value: 150000,
  }, {
    displayText: '$200,000',
    value: 200000,
  }, {
    displayText: '$250,000',
    value: 250000,
  }, {
    displayText: '$300,000',
    value: 300000,
  }, {
    displayText: '$350,000',
    value: 350000,
  }, {
    displayText: '$400,000',
    value: 400000,
  }, {
    displayText: '$450,000',
    value: 450000,
  }, {
    displayText: '$500,000',
    value: 500000,
  }, {
    displayText: '$600,000',
    value: 600000,
  }, {
    displayText: '$700,000',
    value: 700000,
  }, {
    displayText: '$800,000',
    value: 800000,
  }, {
    displayText: '$900,000',
    value: 900000,
  }, {
    displayText: '$1,000,000',
    value: 1000000,
  }, {
    displayText: '$1,250,000',
    value: 1250000,
  }, {
    displayText: '$1,500,000',
    value: 1500000,
  }, {
    displayText: '$2,000,000',
    value: 2000000,
  }, {
    displayText: '$2,500,000',
    value: 2500000,
  }, {
    displayText: '$3,000,000',
    value: 3000000,
  }, {
    displayText: '$4,000,000',
    value: 4000000,
  }, {
    displayText: '$5,000,000',
    value: 5000000,
  }, {
    displayText: '$10,000,000',
    value: 10000000,
  }, {
    displayText: '$25,000,000',
    value: 25000000,
  }, {
    displayText: '$50,000,000',
    value: 50000000,
  }, {
    displayText: '$100,000,000',
    value: 100000000,
  },
];
